import { createMigrate, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_SIGN_OUT,
  USER_UPDATE_REQUEST,
  USER_UPDATE_FAILURE,
  USER_SET_DATA,
} from '../actions/constants';
import { UserActions } from '../actions/user';

export type User = {
  address: string;
  analyticsChecked: boolean;
  birthday: string;
  city: string;
  data: string[];
  email: string;
  fiscalCode?: string;
  houseNumber: string;
  id: string;
  marketingChecked: boolean;
  mobile: string;
  name: string;
  newsletterChecked: boolean;
  password: string;
  postalCode: string;
  privacyChecked: string;
  province: string;
  sex: 'm' | 'f' | null;
  surname: string;
  token: string;
};

export type UserState = {
  data: User | null;
  error: boolean;
  fetching: boolean;
  signedIn: boolean;
};

export const USER_INITIAL_STATE: UserState = {
  data: null,
  error: false,
  fetching: false,
  signedIn: false,
};

export const reducer = (
  state: UserState = USER_INITIAL_STATE,
  action: UserActions
) => {
  switch (action.type) {
    case USER_UPDATE_REQUEST:
    case USER_LOGIN_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        signedIn: true,
      };
    case USER_SET_DATA:
      return {
        ...state,
        data: action.payload,
        error: false,
        fetching: false,
      };
    case USER_UPDATE_FAILURE:
    case USER_LOGIN_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    case USER_SIGN_OUT:
      return USER_INITIAL_STATE;
    default:
      return state;
  }
};

const migrations = {
  1: () => USER_INITIAL_STATE,
  2: (state: any) => ({
    ...state,
    data: {
      ...state.data,
      privacyChecked: '1',
    },
  }),
  3: () => USER_INITIAL_STATE,
  4: () => USER_INITIAL_STATE,
};

const userPersistConfig = {
  key: 'user',
  storage,
  blacklist: ['fetching', 'error'],
  version: 4,
  // @ts-ignore
  migrate: createMigrate(migrations, { debug: false }),
};

export const user = persistReducer(userPersistConfig, reducer);
